import { useEffect } from 'react'
import ConfettiExplosion from 'react-confetti-explosion'
import { useTranslation } from 'react-i18next'

import { LinkButton } from '~/components/link-button'
import { useCardsGameStore } from '~/stores/cards-game'

export const FinishCards = () => {
  const { t } = useTranslation()
  const reset = useCardsGameStore(state => state.reset)

  useEffect(() => {
    reset()
  }, [reset])

  return (
    <div className="flex h-full w-full items-center justify-center">
      <LinkButton onClick={() => reset()} to="/cards">
        {t('Repeat Stack')}
      </LinkButton>
      <div className="absolute left-1/2 top-[25vh] -translate-x-1/2 -translate-y-1/2">
        <ConfettiExplosion />
      </div>
    </div>
  )
}
